import { logger } from '../../datadog/logger';
import { TrackingEvents, sendLoggingEvents } from '../../events';
import { toast } from '../../toasts';
import { ProviderDrawerState, WaitingRoomConversationSidsByVisitorId } from '../state';

export const openWaitingRoomConversation = (
  visitorUuid: string,
  getWaitingRoomConversationSids: () => WaitingRoomConversationSidsByVisitorId,
  openConversation: (
    conversationKind: ProviderDrawerState.WAITING_ROOM_CHAT | ProviderDrawerState.SESSION_CHAT,
    conversationSid: string,
  ) => void,
) => {
  sendLoggingEvents(TrackingEvents.PROVIDER_CLIENT_CHAT);
  const conversations = getWaitingRoomConversationSids();
  const conversationSid = conversations[visitorUuid];

  if (!conversationSid) {
    logger.error('Waiting room conversation not found for visitor', {
      visitorId: visitorUuid,
      conversationSids: Object.keys(conversations),
    });
    toast.error('Unable to open chat with client');
    return;
  }
  openConversation(ProviderDrawerState.WAITING_ROOM_CHAT, conversationSid);
};
